export default __webpack_public_path__ + "static/media/forensics.1225fd16.png";